"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutineOccurrenceSchema = exports.RoutineDefinitionSchema = exports.RoutineTaskSchema = exports.RoutineCompletionSchema = exports.CompletedTaskSchema = exports.CreateRoutineRuleInputSchema = exports.RoutineRuleSchema = exports.RoutineRecurrenceSchema = void 0;
const zod_1 = require("zod");
exports.RoutineRecurrenceSchema = zod_1.z.object({
    freq: zod_1.z.enum(['daily', 'weekly', 'monthly', 'once']),
    interval: zod_1.z.number().int().min(1).default(1),
    byWeekday: zod_1.z.array(zod_1.z.number().int().min(0).max(6)).optional(), // 0=Sun..6=Sat
    byMonthday: zod_1.z.array(zod_1.z.number().int().min(1).max(31)).optional(),
    date: zod_1.z.string().optional(), // YYYY-MM-DD, for freq 'once'
    startDate: zod_1.z.string(), // YYYY-MM-DD
    endDate: zod_1.z.string().nullable().optional(),
});
exports.RoutineRuleSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    name: zod_1.z.string(),
    templateId: zod_1.z.string(),
    targetType: zod_1.z.enum(['location', 'employee']),
    locationId: zod_1.z.string().optional(),
    locationIds: zod_1.z.array(zod_1.z.string()).optional(),
    employeeId: zod_1.z.string().optional(),
    ownership: zod_1.z.enum(['shared', 'per_person']).optional(),
    scheduleDependency: zod_1.z.enum(['independent', 'shift_gated']).optional(),
    recurrence: exports.RoutineRecurrenceSchema,
    active: zod_1.z.boolean().default(true),
    createdAt: zod_1.z.number().optional(),
    updatedAt: zod_1.z.number().optional(),
    createdBy: zod_1.z.string().optional(),
});
exports.CreateRoutineRuleInputSchema = exports.RoutineRuleSchema.omit({
    id: true, tenantId: true, createdAt: true, updatedAt: true,
}).partial({ active: true });
exports.CompletedTaskSchema = zod_1.z.object({
    taskId: zod_1.z.string(),
    byUserId: zod_1.z.string(),
    byName: zod_1.z.string(),
    at: zod_1.z.number(),
});
exports.RoutineCompletionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    ruleId: zod_1.z.string(),
    templateId: zod_1.z.string(),
    date: zod_1.z.string(),
    scope: zod_1.z.enum(['shared', 'person']),
    locationId: zod_1.z.string().optional(),
    employeeId: zod_1.z.string().optional(),
    completedTasks: zod_1.z.array(exports.CompletedTaskSchema).default([]),
    createdAt: zod_1.z.number().optional(),
    updatedAt: zod_1.z.number().optional(),
});
exports.RoutineTaskSchema = zod_1.z.object({
    id: zod_1.z.string(),
    time: zod_1.z.string(),
    type: zod_1.z.enum(['general', 'recipe', 'cleaning', 'special', 'prep', 'inventory', 'safety']),
    description: zod_1.z.string(),
    instructions: zod_1.z.string().optional(),
    recipeId: zod_1.z.string().optional(),
    quantity: zod_1.z.number().optional(),
});
exports.RoutineDefinitionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    category: zod_1.z.string().optional(),
    icon: zod_1.z.string().optional(),
    color: zod_1.z.string().optional(),
    coverImageUrl: zod_1.z.string().optional(),
    aiGenerated: zod_1.z.boolean().optional(),
    locationId: zod_1.z.string().optional(),
    tasks: zod_1.z.array(exports.RoutineTaskSchema).default([]),
});
exports.RoutineOccurrenceSchema = zod_1.z.object({
    ruleId: zod_1.z.string(),
    templateId: zod_1.z.string(),
    name: zod_1.z.string(),
    date: zod_1.z.string(),
    targetType: zod_1.z.enum(['location', 'employee']),
    scope: zod_1.z.enum(['shared', 'person']),
    locationId: zod_1.z.string().optional(),
    employeeId: zod_1.z.string().optional(),
    uncovered: zod_1.z.boolean().default(false),
    completedTasks: zod_1.z.array(exports.CompletedTaskSchema).default([]),
});
//# sourceMappingURL=routine.schema.js.map